import { hasSupabaseConfig, supabase } from '../../../shared/api/supabaseClient.js';
import { loadBossMasterCatalog } from './bossMasterSyncApi.js';
import {
  buildBossSeasonAssignmentPayload,
  normalizeBossSeasonAssignments,
} from '../domain/bossSeasonAssignment.js';

function requireClient() {
  if (!hasSupabaseConfig || !supabase) throw new Error('Supabase 환경 변수가 설정되지 않았습니다.');
  return supabase;
}

export async function loadBossSeasonAssignmentCatalog() {
  const client = requireClient();
  const [seasonResult, bossResult, phaseResult, masters] = await Promise.all([
    client.from('raid_season_catalog').select('id,season_no,status').gte('season_no', 35).order('season_no', { ascending: false }),
    client.from('raid_season_bosses').select('season_id,boss_no,boss_master_id,boss_name,element,coefficient').order('boss_no'),
    client.from('raid_season_boss_phases').select('season_id,boss_no,phase_no,max_hp_eok,is_infinite').lte('phase_no', 3),
    loadBossMasterCatalog(),
  ]);
  const failed = [seasonResult, bossResult, phaseResult].find((result) => result.error);
  if (failed?.error) throw new Error(`시즌 보스 배치를 불러오지 못했습니다: ${failed.error.message}`);
  return {
    masters,
    seasons: normalizeBossSeasonAssignments(seasonResult.data, bossResult.data, phaseResult.data),
  };
}

export async function saveBossSeasonAssignment(draft) {
  const payload = buildBossSeasonAssignmentPayload(draft);
  const { data, error } = await requireClient().rpc('save_platform_raid_season_assignment', {
    p_season_no: payload.seasonNo,
    p_status: payload.status,
    p_bosses: payload.bosses,
  });
  if (error) {
    const messages = {
      platform_admin_required: '플랫폼 관리자만 시즌 보스 배치를 저장할 수 있습니다.',
      invalid_season_no: '35시즌 이후 차수만 설정할 수 있습니다.',
      invalid_boss_payload: '보스 배치와 체력 값을 확인해주세요.',
      five_bosses_required: '1번부터 5번까지 보스를 모두 설정해주세요.',
      duplicate_boss_master: '한 시즌에 같은 보스를 중복 배치할 수 없습니다.',
      duplicate_boss_element: '한 시즌의 약점 속성은 서로 중복될 수 없습니다.',
      boss_master_not_found: '선택한 Boss Master를 찾을 수 없습니다.',
    };
    const code = Object.keys(messages).find((key) => String(error.message || '').includes(key));
    throw new Error(messages[code] || `시즌 보스 배치를 저장하지 못했습니다: ${error.message}`);
  }
  return data;
}

export async function setBossSeasonStatus(seasonNo, status) {
  const { data, error } = await requireClient().rpc('set_platform_raid_season_status', {
    p_season_no: Number(seasonNo), p_status: status,
  });
  if (error) {
    const messages = {
      platform_admin_required: '플랫폼 관리자만 시즌을 공개·종료할 수 있습니다.',
      platform_season_incomplete: '보스 5개와 1~3단 체력, 5번 보스의 무한 단계를 먼저 저장해주세요.',
      platform_season_not_registered: '먼저 시즌 설정을 저장해주세요.',
      platform_season_not_published: '아직 공개하지 않은 시즌입니다.',
    };
    const code = Object.keys(messages).find((key) => String(error.message).includes(key));
    throw new Error(messages[code] || `시즌 상태를 변경하지 못했습니다: ${error.message}`);
  }
  return data;
}
